/**
 * Zero-rows body for grid-shaped tiles (table/pivot): keeps the result's
 * COLUMN HEADERS visible over the empty-state copy, so "no rows" reads as
 * "the query ran and returned this shape" instead of a blank/broken tile.
 * Rendered by `QueryTileStates` when a successful run has columns but no rows.
 */

/** Header row stays legible — beyond this we summarize instead of slivers. */
const MAX_SHOWN_COLUMNS = 12;

export function TileEmptyShape({ columns, copy }: { columns: string[]; copy: string }) {
  const shown = columns.slice(0, MAX_SHOWN_COLUMNS);
  const extra = columns.length - shown.length;
  return (
    <div className="flex h-full min-h-0 flex-col" data-testid="tile-empty-shape">
      <table className="w-full shrink-0 table-fixed border-collapse text-xs">
        <thead>
          <tr>
            {shown.map((name, i) => (
              <th
                key={`${name}-${i}`}
                className="truncate border-b border-border px-2 py-1 text-left font-medium text-muted-foreground"
                title={name}
                data-testid="tile-empty-shape-header"
              >
                {name}
              </th>
            ))}
            {extra > 0 && (
              <th className="truncate border-b border-border px-2 py-1 text-left font-normal italic text-muted-foreground">
                +{extra} more
              </th>
            )}
          </tr>
        </thead>
      </table>
      <div
        className="flex min-h-0 flex-1 items-center justify-center px-3 py-2 text-center text-xs text-muted-foreground"
        data-testid="tile-empty-shape-copy"
      >
        {copy}
      </div>
    </div>
  );
}
